import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import TooltipWrapper from "@memorang/ui/components/TooltipWrapper";
import type { IconType } from "@memorang/ui/icon";
import { Chip, type ChipProps } from "react-native-paper";

type Props = {
	tooltip: string;
	text: string;
	icon: string;
	mode: ChipProps["mode"];
};
export const PremiumChip = ({ tooltip, text, icon, mode }: Props) => {
	return (
		<TooltipWrapper title={tooltip}>
			<Chip
				compact
				icon={(props) => <Icon name={icon as IconType} {...props} />}
				style={{
					alignSelf: "center",
				}}
				mode={mode}
			>
				{text}
			</Chip>
		</TooltipWrapper>
	);
};
